import { useEffect, useState } from "react"
import "./css/WallPage.css"
import { useLocation, useNavigate } from "react-router-dom"
import { BASE_URL } from "../../utils/Constants"

const WallPage = () => {

  const navigate = useNavigate()
  const location = useLocation()
  const name = location.state.name
  const idToken = location.state.idToken
  const accessToken = location.state.accessToken
  const userId = location.state.userId
  const refreshToken = location.state.refreshToken

  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    callGetMedicalUserApi()
  }, [])

  const requestOptionsGET = {
    method: 'GET',
    headers: {
      'Authorization': idToken!
    }
  }

  // GET users info by user_id
  async function callGetMedicalUserApi() {
    setIsLoading(true)
    const responseUserinfo = await fetch(`${BASE_URL}/api/medical-user/${userId}`, requestOptionsGET)
    setIsLoading(false)
    if (responseUserinfo.ok) {
      const responseJson = await responseUserinfo.json()
      console.log(responseJson)
      if (responseJson.calendly_data.calendly_invitation_status !== "pending") {
        navigate("/platform-experts")
      }
    } else if (responseUserinfo.status === 401) {
      // call refreshToken
      navigate("/login")
    } else {
      const responseJson = await responseUserinfo.json()
      console.log(responseJson)
    }
  }

  async function callSyncCalendlyApi() {
    setIsLoading(true)
    const responseUserinfo = await fetch(`${BASE_URL}/api/medical-user/sync-calendly/${userId}`, {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': idToken!,
      },
    })
    setIsLoading(false)
    if (responseUserinfo.ok) {
      const responseJson = await responseUserinfo.json()
      if (responseJson.calendly_data.calendly_invitation_status !== "pending") {
        navigate("/platform-experts", { state: { userId, idToken } })
      }
    } else {
      const responseInfoJson = await responseUserinfo.json()
      console.log(responseInfoJson)
    }
  }

  return (
    <div className="App">
      <div className="wall-page-full-container">
        <div className="wall-page-internal-container">
          <div className="wall-page-content">
            <div>
              <img src="/images/holifyaLogos/holifya-logo-blue.svg" />
            </div>
            <div className="wall-page-heading">
              Fantastico!
            </div>
            <div className="wall-page-copy">
              Hai ricevuto una mail con l'invito a connetterti al nostro Calendly.
              Prosegui da lì per selezionare le tue disponibilità.
            </div>
            <div className="wall-page-image-container" />
            <button
              className="wall-page-button primary-action-color-background standard-uppercase-text"
              onClick={callSyncCalendlyApi}
            >
              Registrazione effettuata
            </button>
            <div className="wall-page-copy">
              Una volta che avrai settato il tuo account collegato Calendly avrai accesso alla tua area personale Holifya.
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WallPage
